:host {
  display: flex;
  width: 100%;
  border-bottom: 1px solid var(--theme-secondary-border);
}
:host([flex]) ::slotted(*) {
  flex: 1 1;
  justify-content: center;
}
